import { useState } from "react";
import { Link } from "react-router-dom";
import { TextField, Typography } from "@mui/material";
import SupportTicketList from "components/SupportTickets/SupportTicketList";
import { useDebouncedValue } from "hooks/useDebouncedValue";
import { SUPPORT_KEY, listSupportTickets, supportTicketPath } from "../supportTicketsApi";

const Section = ({ title, children }) => (
  <section className="rounded-lg border border-app-border bg-app-surface p-4">
    <Typography variant="subtitle1" className="font-semibold" sx={{ mb: 2 }}>
      {title}
    </Typography>
    {children}
  </section>
);

/**
 * Every partner's support tickets. Open ones are their own queue at the top, so a new issue is
 * never buried under resolved history; the full list below pages separately and can be searched.
 */
const SupportTicketsPage = () => {
  const [search, setSearch] = useState("");
  const debounced = useDebouncedValue(search.trim(), 300);
  const searchParam = debounced ? { search: debounced } : {};

  return (
    <div className="mt-4 px-4 pb-12 space-y-4 dashBody">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <Link to="/admin/admin-referral" className="text-xs text-app-text-muted no-underline">
            ← Referral partners
          </Link>
          <Typography variant="h6" className="font-semibold">
            Partner support tickets
          </Typography>
        </div>
        <TextField
          size="small"
          label="Search titles"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
        />
      </div>
      <Section title="Open tickets">
        <SupportTicketList
          queryKey={[...SUPPORT_KEY, "list", "OPEN"]}
          fetchPage={listSupportTickets}
          params={{ status: "OPEN", ...searchParam }}
          pageSize={10}
          linkTo={supportTicketPath}
          showPartner
          emptyText="No open tickets."
        />
      </Section>
      <Section title="All tickets">
        <SupportTicketList
          queryKey={[...SUPPORT_KEY, "list", "ALL"]}
          fetchPage={listSupportTickets}
          params={{ status: "ALL", ...searchParam }}
          pageSize={15}
          linkTo={supportTicketPath}
          showPartner
          emptyText="No tickets yet."
        />
      </Section>
    </div>
  );
};

export default SupportTicketsPage;
